<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div class="tabulator-parent">
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-shopping-basket"></i> {{ _('Johku App') }}</h3>
        </div>
      </div>
      <editor-tabs id="tabNavi" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition-group name="fade">
          <div v-bind="tabPanel('pointsofuse')" class="tab-pane active" id="pointsofuse" v-if="isTabActive('pointsofuse')" key="pointsofuse">
            <div class="row">
              <div class="col-sm-6">
                <h3>{{ _('Points of use') }}</h3>
              </div>
              <div class="col-sm-6">
                <button type="button" class="btn btn-success btn-new pull-right new-pos" v-on:click="addPosDialog"><i class="fa fa-fw fa-plus"></i> {{ _('New point of use') }}</button>
              </div>
            </div>
            <Datatable :url="posesUrl" :options="posesTableOptions" ref="datatablePoses" />
          </div>
          <div v-bind="tabPanel('components')" class="tab-pane active" id="components" v-if="isTabActive('components')" key="components">
            <div class="row">
              <div class="col-sm-6">
                <h3>{{ _('Components') }}</h3>
                <p class="help-block" v-if="isFeatureEnabled('uifeatures')"><a href="javascript:;" v-on:click="openCatalog">{{ _('Ready-made screens') }}</a> — {{ _('Add a complete menu section with the components already in place.') }}</p>
              </div>
              <div class="col-sm-6">
                <button type="button" class="btn btn-success btn-new pull-right new-component" v-on:click="addComponentDialog"><i class="fa fa-fw fa-plus"></i> {{ _('New component') }}</button>
              </div>
            </div>
            <Datatable :url="componentsUrl" :options="componentsTableOptions" ref="datatableComponents" />
          </div>
          <div v-bind="tabPanel('layouts')" class="tab-pane active" id="layouts" v-if="isTabActive('layouts')" key="layouts">
            <div class="row">
              <div class="col-sm-6">
                <h3>{{ _('Layout sections') }}</h3>
                <p class="help-block" v-if="isFeatureEnabled('uifeatures')"><a href="javascript:;" v-on:click="openCatalog">{{ _('Ready-made screens') }}</a> — {{ _('Add a complete menu section with the components already in place.') }}</p>
              </div>
              <div class="col-sm-6">
                <button type="button" class="btn btn-success btn-new pull-right new-layout" v-on:click="addLayoutDialog"><i class="fa fa-fw fa-plus"></i> {{ _('New layout section') }}</button>
              </div>
            </div>
            <Datatable :url="layoutsUrl" :options="layoutsTableOptions" ref="datatableLayouts" />
          </div>
          <div v-bind="tabPanel('userinterfaces')" class="tab-pane active" id="userinterfaces" v-if="isTabActive('userinterfaces')" key="userinterfaces">
            <div class="row">
              <div class="col-sm-6">
                <h3>{{ _('User interfaces') }}</h3>
                <p><span>{{ _('Identifier') }}:</span> <strong>{{ clientid }}</strong></p>
              </div>
              <div class="col-sm-6">
                <button type="button" class="btn btn-success pull-right new-userinterface" v-on:click="addUserinterfaceDialog"><i class="fa fa-fw fa-plus"></i> {{ _('New user interface') }}</button>
              </div>
            </div>
            <Datatable :url="userinterfacesUrl" :options="userinterfacesTableOptions" ref="datatableUserinterfaces" />
          </div>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import componenttypes from '~/lib/componenttypes'
import formatters from '~/lib/formatters'
import { Datatable } from '#components'
import { mapGetters } from 'vuex'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      poses: [],
      localSettings: null,
      activeTab: 'pointsofuse',
      posesTableOptions: {
        fixWidths: true,
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 70,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 4,
          formatter: this.pointOfUseNameFormatter(this.getPosId),
          responsive: 0
        },
        ],
        initialSort: [{
          column: 'name',
          dir: 'asc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const name = row.getCell('name').getValue()
          $this.editPos(id, name)
        }
      },
      componentsTableOptions: {
        fixWidths: true,
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 70
        },
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 4
        },
        {
          title: _('Type'),
          field: 'type',
          widthGrow: 4,
          formatter: this.componentTypeFormatter()
        },
        ],
        initialSort: [{
          column: 'name',
          dir: 'asc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const name = row.getCell('name').getValue()
          $this.editComponent(id, name)
        }
      },
      layoutsTableOptions: {
        fixWidths: true,
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 70,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 4,
          responsive: 0,
          formatter: this.layoutNameFormatter()
        },
        ],
        initialSort: [{
          column: 'name',
          dir: 'asc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const name = row.getCell('name').getValue()
          $this.editLayout(id, name)
        }
      },
      userinterfacesTableOptions: {
        fixWidths: true,
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 70,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 4,
          formatter: this.userinterfaceNameFormatter(this.getClientId),
          responsive: 0
        },
        {
          title: _('Type'),
          field: 'floating',
          widthGrow: 2,
          formatter: this.floatingFormatter()
        },
        {
          title: _('Identifier'),
          field: 'identifier',
          widthGrow: 3
        },
        ],
        initialSort: [{
          column: 'name',
          dir: 'asc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const name = row.getCell('name').getValue()
          $this.editUserinterface(id, name)
        }
      }
    }
  },
  mixins: [components, componenttypes, formatters],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'pointsofuse', label: this._('Points of use') },
        { id: 'userinterfaces', label: this._('User interfaces') },
        { id: 'layouts', label: this._('Layout sections') },
        { id: 'components', label: this._('Components') }
      ])
    },
    ...mapGetters(['clientid', 'pos']),
    posesUrl () {
      return this.baseDomain + this.shopId + '/pos.json?apikey=' + this.apiKey
    },
    componentsUrl () {
      return this.baseDomain + this.shopId + '/components.json?apikey=' + this.apiKey + '&version=' + this.version
    },
    layoutsUrl () {
      return this.baseDomain + this.shopId + '/layouts.json?apikey=' + this.apiKey + '&version=' + this.version
    },
    userinterfacesUrl () {
      return this.baseDomain + this.shopId + '/clients.json?apikey=' + this.apiKey
    },
    settings: {
      get () {
        return this.localSettings ? this.localSettings : this.shopSettings(this.shopId)
      },
      set (newValue) {
        this.localSettings = newValue
      }
    },
    editorConfig () {
      return {
        toolbar:
          [
            ['Format', 'Bold', 'Italic', '-', 'NumberedList', 'BulletedList', 'Outdent', 'Indent', '-', 'Link', 'Unlink'],
            ['JustifyLeft', 'JustifyCenter', 'JustifyRight'],
            ['Undo', 'Redo'],
            ['Source'],
            ['UIColor']
          ],
        height: '200px',
        language: this.shortLocale,
        allowedContent: true,
        extraPlugins: 'justify'
      }
    },
    componentOptions () {
      return this.componentTypes.map(c => { return { value: c.type, name: c.name, desc: c.type }}).sort((a, b) => a.name > b.name ? 1 : -1)
    }
  },
  methods: {
    getPosId () {
      return this.pos
    },
    getClientId () {
      return this.clientid
    },
    addPosDialog () {
      this.showDialog({
        title: this._('New cash register'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'save',
            requiredFields: ['name'],
            handler: this.addPos
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name'
          }
        ]
      })
    },
    async addPos (data) {
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/pos.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        return
      }
      this.editPos(response.data, data.name, 'general')
    },
    editPos (id, name, activeTab, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'PosDetails',
        title: this._('Point of use') + ' ' + id + (name ? ': ' + name : ''),
        width: 6,
        data: {
          posId: id,
          activeTab
        },
        skipState
      })
    },
    addComponentDialog () {
      this.showDialog({
        title: this._('New component'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'save',
            requiredFields: ['name', 'type'],
            handler: (data) => {
              const d = {
                name: data.name,
                type: data.type.value
              }
              this.addComponent(d)
            }
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name'
          },
          {
            title: this._('Type'),
            type: 'selectize',
            name: 'type',
            options: this.componentOptions
          }
        ]
      })
    },
    async addComponent (data) {
      let response
      if (data.type === 'Receipt') {
        data.data = JSON.stringify({
          defaultCustomerType: "client",
          disablePayments: [],
          enableBilling: "0",
          index: "1"
        })
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/components.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        return
      }
      this.editComponent(response.data, data.name)
    },
    editComponent (id, name, activeTab, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'ComponentDetails',
        title: this._('Component') + ' ' + id + (name ? ': ' + name : ''),
        width: 6,
        data: {
          componentId: id,
          activeTab
        },
        skipState
      })
    },
    addLayoutDialog () {
      this.showDialog({
        title: this._('New layout section'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'save',
            requiredFields: ['name'],
            handler: this.addLayout
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name'
          }
        ]
      })
    },
    async addLayout (data) {
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/layouts.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        return
      }
      this.editLayout(response.data, data.name)
    },
    editLayout (id, name, activeTab, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'LayoutDetails',
        title: this._('Layout section') + ' ' + id + (name ? ': ' + name : ''),
        width: 6,
        data: {
          layoutId: id,
          activeTab
        },
        skipState
      })
    },
    addUserinterfaceDialog () {
      this.showDialog({
        title: this._('New user interface'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'save',
            requiredFields: ['name'],
            handler: this.addUserinterface
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name'
          }
        ]
      })
    },
    async addUserinterface (data) {
      let response
      try {
        data.floating = 1
        response = await axios.post(this.baseDomain + this.shopId + '/clients.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        return
      }
      this.editUserinterface(response.data, data.name)
    },
    editUserinterface (id, name, activeTab, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'UserinterfaceDetails',
        title: this._('User interface') + ' ' + id + (name ? ': ' + name : ''),
        width: 6,
        data: {
          userinterfaceId: id,
          activeTab
        },
        skipState
      })
    },
    reloadPosList () {
      if (this.$refs.datatablePoses) {
        this.$refs.datatablePoses.reload()
      }
    },
    reloadComponentsList () {
      if (this.$refs.datatableComponents) {
        this.$refs.datatableComponents.reload()
      }
    },
    reloadLayoutsList () {
      if (this.$refs.datatableLayouts) {
        this.$refs.datatableLayouts.reload()
      }
    },
    reloadUserinterfacesList () {
      if (this.$refs.datatableUserinterfaces) {
        this.$refs.datatableUserinterfaces.reload()
      }
    },
    openCatalog () {
      this.EventBus.$emit('showComponent', {
        shopId: this.shopId,
        component: 'UiFeatureCatalog',
        title: this._('Ready-made screens')
      })
    }
  },
  components: {
    Datatable
  },
  mounted () {
    this.localSettings = Object.assign({}, this.settings)
    if(!this.events) {
      let events = {}
      events['posUpdate'] = (message) => {
        return this.reloadPosList()
      }
      events['componentUpdate'] = (message) => {
        return this.reloadComponentsList()
      }
      events['layoutUpdate'] = (message) => {
        return this.reloadLayoutsList()
      }
      events['clientUpdate'] = (message) => {
        return this.reloadUserinterfacesList()
      }
      events['restoreDetails'] = (message) => {
        if (message.shopId !== this.shopId) {
          return
        }
        switch(message.component) {
          case 'PosDetails':
            this.editPos(message.data.posId, null, null, true)
            break
          case 'ComponentDetails':
            this.editComponent(message.data.componentId, null, null, true)
            break
          case 'LayoutDetails':
            this.editLayout(message.data.layoutId, null, null, true)
            break
          case 'UserinterfaceDetails':
            this.editUserinterface(message.data.userinterfaceId, null, null, true)
            break
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>